import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../utilities/contexts";
import { launchSourceOne, staticURL } from "../../../utilities/requests";
import getIndexedDB from "../../../utilities/indexedDB/getIndexedDB";
import { ECLFeatureFlag, ECLLoader, ECLUserProfile } from "../../index";
import ECLDialog from "../ECLDialog/ECLDialog";
import { translate } from "../../../utilities/Translate";
import useSelectorId from "../../../utilities/hooks/useSelectorId";
import "./ECLUserInfo.css";

const indexedDB = getIndexedDB();

//ECLUserInfo will conditionally render user information when provided with a user's ID.
//PROPS:
//user - UUID - optional - powers all the queries that populate information within this component.  If not provided, defaults
//to current user
//hideName - BOOL - optional - defaults to false, removes name header
//header - bool - optional - when included, enlarges avatar for header size
//richText - bool - optional - strips container div
//clickShowsProfile - bool - default is true, if true when you click on the username, it opens profile
export default function ECLUserInfo(props) {
   const userInfoId = useSelectorId();
   const users = useContext(UserContext);
   const [user, setUser] = useState(null);
   const [avatarSrc, setAvatarSrc] = useState(
      staticURL + "icons/Eclipse/user-icon-both-themes.svg",
   );

   useEffect(() => {
      if (users) {
         if (!user) {
            setUser(props.user ? users.get(props.user) : users.currentUser);
         } else if (user && user.avatar !== "none" && user.avatar !== "") {
            if (user.avatar.indexOf("_CUSTOM") !== -1) {
               indexedDB
                  .get("customAvatars", user.id)
                  .then((res) => {
                     setAvatarSrc("data:image/webp;base64," + res.data);
                     document.querySelector(
                        "#avatar-" + user.id + userInfoId,
                     ).src = "data:image/webp;base64," + res.data;
                  })
                  .catch((error) => console.error(error));
            } else {
               indexedDB
                  .get("defaultAvatars", user.avatar)
                  .then((res) => {
                     setAvatarSrc("data:image/webp;base64," + res.data);
                     document.querySelector(
                        "#avatar-" + user.id + userInfoId,
                     ).src = "data:image/webp;base64," + res.data;
                  })
                  .catch((error) => console.error(error));
            }
         }
      }
   }, [users, user]);
   //Decides the style based on header prop
   const fashion = props.header ? "-header" : "";

   if (!users) {
      return <ECLLoader />;
   }

   if (!user) {
      return null;
   }

   if (props.richText) {
      return (
         <>
            <ECLFeatureFlag ffKey="User Component (Old)">
               <div
                  className={"user-info-container-rich-text"}
                  data-hide-name={props.hideName ? "true" : ""}
                  onClick={() => {
                     launchSourceOne("usr", [props.projectID, props.user]);
                  }}
               >
                  {!props.hideName ? (
                     <a
                        onClick={(e) => {
                           e.preventDefault();
                        }}
                     >
                        {user.deactivated
                           ? user.username + " [INACTIVE]"
                           : user.username}
                     </a>
                  ) : (
                     ""
                  )}
                  <img
                     id={"avatar-" + user.id + userInfoId}
                     src={staticURL + "icons/Eclipse/user-icon-both-themes.svg"}
                     alt={translate(user.username + " avatar")}
                  />
               </div>
            </ECLFeatureFlag>

            {/* This part is turned off for now */}
            <ECLFeatureFlag ffKey="User Profile (New)">
               {props.clickShowsProfile === false ? (
                  <div
                     className={"user-info-container-rich-text"}
                     data-hide-name={props.hideName ? "true" : ""}
                     onClick={() => {
                        launchSourceOne("usr", [props.projectID, props.user]);
                     }}
                  >
                     {!props.hideName ? (
                        <a
                           onClick={(e) => {
                              e.preventDefault();
                           }}
                        >
                           {user.deactivated
                              ? user.username + " [INACTIVE]"
                              : user.username}
                        </a>
                     ) : (
                        ""
                     )}
                     <img
                        id={"avatar-" + user.id + userInfoId}
                        src={
                           staticURL + "icons/Eclipse/user-icon-both-themes.svg"
                        }
                        alt={translate(user.username + " avatar")}
                     />
                  </div>
               ) : (
                  <ECLDialog
                     title={translate("User Profile")}
                     customButtons={{}}
                     triggerText={
                        <>
                           <div
                              className={"user-info-container-rich-text"}
                              data-hide-name={props.hideName ? "true" : ""}
                           >
                              {!props.hideName ? (
                                 <a
                                    onClick={(e) => {
                                       e.preventDefault();
                                    }}
                                 >
                                    {user.deactivated
                                       ? user.username + " [INACTIVE]"
                                       : user.username}{" "}
                                 </a>
                              ) : (
                                 ""
                              )}
                              <img
                                 id={"avatar-" + user.id + userInfoId}
                                 src={
                                    staticURL +
                                    "icons/Eclipse/user-icon-both-themes.svg"
                                 }
                                 alt={translate(user.username + " avatar")}
                              />
                           </div>
                        </>
                     }
                     triggerClass="user-profile-trigger"
                  >
                     <ECLUserProfile
                        user={user}
                        avatarSrc={avatarSrc}
                     ></ECLUserProfile>
                  </ECLDialog>
               )}
            </ECLFeatureFlag>
         </>
      );
   } else {
      return (
         <>
            <ECLFeatureFlag ffKey="User Component (Old)">
               <div
                  className={"user-info-container" + fashion}
                  data-hide-name={props.hideName ? "true" : ""}
               >
                  {!props.hideName ? (
                     <label htmlFor={props.user + "-avatar"}>
                        {user.deactivated
                           ? user.username + " [INACTIVE]"
                           : user.username}
                     </label>
                  ) : (
                     ""
                  )}
                  <img
                     id={"avatar-" + user.id + userInfoId}
                     src={staticURL + "icons/Eclipse/user-icon-both-themes.svg"}
                     alt={translate(user.username + " avatar")}
                  />
               </div>
            </ECLFeatureFlag>
            {/* This part is turned off for now */}
            <ECLFeatureFlag ffKey="User Profile (New)">
               {props.clickShowsProfile === false ? (
                  <div
                     className={"user-info-container" + fashion}
                     data-hide-name={props.hideName ? "true" : ""}
                  >
                     {!props.hideName ? (
                        <a
                           onClick={(e) => {
                              e.preventDefault();
                           }}
                        >
                           <label htmlFor={props.user + "-avatar"}>
                              {user.deactivated
                                 ? user.username + " [INACTIVE]"
                                 : user.username}
                           </label>
                        </a>
                     ) : (
                        ""
                     )}
                     <img
                        id={"avatar-" + user.id + userInfoId}
                        src={
                           staticURL + "icons/Eclipse/user-icon-both-themes.svg"
                        }
                        alt={translate(user.username + " avatar")}
                     />
                  </div>
               ) : (
                  <ECLDialog
                     title={translate("User Profile")}
                     customButtons={{}}
                     triggerText={
                        <>
                           <div
                              className={"user-info-container" + fashion}
                              data-hide-name={props.hideName ? "true" : ""}
                           >
                              {!props.hideName ? (
                                 <a
                                    onClick={(e) => {
                                       e.preventDefault();
                                    }}
                                 >
                                    <label htmlFor={props.user + "-avatar"}>
                                       {user.deactivated
                                          ? user.username + " [INACTIVE]"
                                          : user.username}
                                    </label>
                                 </a>
                              ) : (
                                 ""
                              )}
                              <img
                                 id={"avatar-" + user.id + userInfoId}
                                 src={
                                    staticURL +
                                    "icons/Eclipse/user-icon-both-themes.svg"
                                 }
                                 alt={translate(user.username + " avatar")}
                              />
                           </div>
                        </>
                     }
                     triggerClass="user-profile-trigger"
                  >
                     <ECLUserProfile
                        user={user}
                        avatarSrc={avatarSrc}
                     ></ECLUserProfile>
                  </ECLDialog>
               )}
            </ECLFeatureFlag>
         </>
      );
   }
}
